<div id="notfound">
		<div class="notfound" style="background-color: white; border-radius: 20px;">
		<img src="assets/logo.png" width="100"/>
			<div class="notfound-404">
				<h3 style="color: rgb(0, 0, 0);">Oops! Está Página está fora do ar</h3>
				<h1><span>4</span><span>0</span><span>4</span></h1>
			</div>
            <h2 style="color: rgb(0, 0, 0);">O caminho que digitou, não existe.</h2>
            <button pButton type="button" icon="pi pi-fw pi-user" label="Login" [routerLink]="['/login']" class="p-button-raised p-button-rounded"></button>
        </div>       
</div>
